import { MoreHoriz } from "@mui/icons-material";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Popover,
  Tooltip,
} from "@mui/material";
import React from "react";
import { IContextMenuProps, IMenuOption } from "./interfaces/IContextMenuProps";

export const ContextMenu: React.FC<IContextMenuProps> = (props) => {
  const { menuOptions, subheader = "Actions" } = props;
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: any) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event?: any) => {
    if (event?.stopPropagation) {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleMenuItemClick = (menuItem: IMenuOption) => (event: React.MouseEvent) => {
    event.stopPropagation();
    if (menuItem.onClick && !menuItem.disabled) {
      menuItem.onClick();
      setAnchorEl(null);
    }
  };

  return (
    <>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 24,
          height: 24,
          flexShrink: 0,
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        <Tooltip title="More">
          <MoreHoriz color="primary" />
        </Tooltip>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          style: { minWidth: "200px" },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            subheader ? (
              <ListSubheader component="div" id="nested-list-subheader">
                {subheader}
              </ListSubheader>
            ) : undefined
          }
        >
          {menuOptions.map((menuItem) => {
            return (
              <ListItemButton
                disabled={menuItem.disabled}
                key={menuItem.label}
                onClick={handleMenuItemClick(menuItem)}
              >
                <ListItemIcon sx={{ mr: 1 }}>{menuItem.icon}</ListItemIcon>
                <ListItemText primary={menuItem.label} />
              </ListItemButton>
            );
          })}
        </List>
      </Popover>
    </>
  );
};